import classNames from "classnames"
import { CSSProperties, FC, useEffect, useState } from "react"
import { useBarcodeReaderContext } from "../../system/providers/barcodeReaderGlobal"
import styles from "./select.module.scss"
import { PopoverClue } from "../popoverClue/PopoverClue"

export interface IOption {
    displayName: string
    value: any
    hidden?: boolean
    propertyType?: string
}

interface ISelectProps {
    defaultOption?: IOption
    options?: IOption[]
    onSelect: (value: IOption) => void
    value?: IOption
    clues?: string[]
    disabled?: boolean
    required?: boolean
    barcodeScan?: boolean
    className?: string
    label?: string
    inline?: boolean
    style?: CSSProperties
    onMouseEnter?: () => void
    onMouseLeave?: () => void
    error?: string
    onFocus?: () => void
}

export const Select: FC<ISelectProps> = (props) => {
    const [option, setOption] = useState<IOption | undefined>()
    const barcodeReaderContext = useBarcodeReaderContext()

    useEffect(() => {
        if (option) props.onSelect?.(option)
    }, [option])

    useEffect(() => {
        if (props.barcodeScan && barcodeReaderContext.barcodeScanFlag) {
            if (barcodeReaderContext.barcode.length === 13 && props.options?.find((item) => item.value === "internalBarcode") && barcodeReaderContext.barcode.startsWith("2000")) {
                props.onSelect?.(props.options?.find((item) => item.value === "internalBarcode") as IOption)
            } else if (barcodeReaderContext.barcode.length === 13 && props.options?.find((item) => item.value === "barcodeCode")) {
                props.onSelect?.(props.options?.find((item) => item.value === "barcodeCode") as IOption)
            } else if (barcodeReaderContext.barcode.length === 13 && props.options?.find((item) => item.value === "barcode")) {
                props.onSelect?.(props.options?.find((item) => item.value === "barcode") as IOption)
            } else if (
                (barcodeReaderContext.barcode.length === 20 ||
                    barcodeReaderContext.barcode.length === 28 ||
                    barcodeReaderContext.barcode.length === 32 ||
                    barcodeReaderContext.barcode.length === 83 ||
                    barcodeReaderContext.barcode.length === 85 ||
                    barcodeReaderContext.barcode.length === 86) &&
                props.options?.find((item) => item.value === "kizOrKizBox")
            ) {
                props.onSelect?.(props.options?.find((item) => item.value === "kizOrKizBox") as IOption)
            } else if (barcodeReaderContext.barcode.length === 20 && props.options?.find((item) => item.value === "KizBox")) {
                props.onSelect?.(props.options?.find((item) => item.value === "KizBox") as IOption)
            } else {
                if (option) props.onSelect?.(option)
            }
        }
    }, [barcodeReaderContext.barcodeScanFlag])

    return (
        <div
            className={classNames(styles.select, props.className, props.inline && styles.selectInline)}
            onMouseEnter={props.onMouseEnter} // Передаем onMouseEnter
            onMouseLeave={props.onMouseLeave} // Передаем onMouseLeave
        >
            {props.label && (
                <div>
                    <label className={styles.select__label}>{props.required ? <strong>{`${props.label} *`}</strong> : props.label}</label>
                </div>
            )}
            <div
                style={{display : props.clues && 'flex'}}
            >
                <select
                    className={classNames(styles.select__custom, props.disabled && styles.select__customDisabled, props.error && styles.select__customError)}
                    defaultValue={props.defaultOption?.value}
                    disabled={props.disabled}
                    style={props.style}
                    onKeyDown={(e) => {
                        if (e.key === "Escape") {
                            e.currentTarget.blur()
                        }
                    }}
                    onChange={(event) => {
                        if (props.options && props.options.length > 0) {
                            const opt = props.options[event.currentTarget.selectedIndex]
                            setOption(opt)
                        }
                    }}
                    onFocus={() => {
                        props.onFocus?.()
                    }}
                    value={props.value?.value}
                >
                    {props.options &&
                        props.options.length > 0 &&
                        props.options.map((item, index) => {
                            return (
                                <option key={index} value={item.value} hidden={item.hidden}>
                                    {" "}
                                    {item.displayName}{" "}
                                </option>
                            )
                        })}
                </select>
                {
                    props.clues && (
                        <PopoverClue
                            clues={props.clues}
                        />
                    )
                }
                {props.error && <span className={styles.errorMessage}>{props.error}</span>}
            </div>
        </div>
    )
}
